import React from 'react';
import SalesChannelList from '../components/sales/SalesChannelList';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../contexts/LanguageContext';

const Sales: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6 pb-20 sm:pb-0">
      <CommonPageHeader
        title={t('sales.title') || 'Értékesítés'}
        subtitle={t('sales.subtitle') || 'Értékesítési csatornák és rendelések kezelése'}
        icon={ShoppingCartIcon}
      />
      
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md border border-gray-200 dark:border-gray-700">
        <SalesChannelList />
      </div>
    </div>
  );
};

export default Sales;